export default __webpack_public_path__ + "static/media/bodycard6.efb14e11.png";